export default defineNuxtPlugin({
    name: 'customerContactsCache',

    setup() {
        const { isLoggedIn } = useAuthUtils();
        const { clearCached } = useCustomerContactsCache();

        watch(
            isLoggedIn,
            value => {
                if (value) clearCached();
            },
            { immediate: true }
        );
    },
});
